import Map from '../components/Map'
import Loader from '../components/Loader'
import Header from '../components/Header'

import { useGetStatesQuery } from '../store/atfStateApiSlice'
import { useGetRegionsQuery } from '../store/atfRegionApiSlice';
import { useGetPOIsQuery } from '../store/atfPoiApiSlice';
import { useGetCategoriesQuery } from '../store/atfCategoryApiSlice'
import { useSelector } from 'react-redux';

const Home = () => {
    const { data: states = [], isFetching: statesFetching } = useGetStatesQuery();
    const { data: regions = [], isFetching: regionsFetching } = useGetRegionsQuery();
    const { data: entities = [], isFetching: entitiesFetching } = useGetPOIsQuery();
    const { data: categories = [], isFetching: categoriesFetching } = useGetCategoriesQuery();
    const loadingProgress = useSelector(state => state.loadingProgress);

    const loading = statesFetching || regionsFetching || categoriesFetching || entitiesFetching;

    return (
        <div>
            <Header />
            {!loading
            ? <Map />
            : <Loader progress={loadingProgress} />}
        </div>
    );
}

export default Home;
